import axios from "axios"

export const getLocalWeather = async (zipcode: string) => {
  const response = await axios.get(`${import.meta.env.VITE_WEATHER_API_URL}`, {
    params: {
      key: import.meta.env.VITE_WEATHER_API_KEY,
      q: zipcode,
    },
  })

  return response.data
}
